import React from "react";
import { Link } from "react-router-dom";
import MyCustomTable from "components/MyCustomTable";

const Domains = () => {
    const columns = React.useMemo(
        () => [
            {
                accessorFn: (row) => row.name,
                accessorKey: "name",
                header: () => <span className="text-gray-400">NOME</span>,
                enableResizing: false,
                enableSorting: false,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <p className="text-sm text-blue-600">
                        <Link
                            to={{
                                pathname: `/my/domain/${props.cell.getValue()}`,
                            }}
                            className="text-xs hover:text-blue-500 dark:hover:text-white sm:text-sm"
                        >
                            {props.cell.getValue()}
                        </Link>
                    </p>
                ),
            },
            {
                accessorFn: (row) => row.customer,
                accessorKey: "customer",
                header: () => (
                    <>
                        <span className="table-cell text-gray-400 md:hidden">
                            INFO
                        </span>
                        <span className="hidden text-gray-400 md:table-cell">
                            CLIENTE
                        </span>
                    </>
                ),
                enableSorting: false,
                footer: (props) => props.column.id,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span className="table-cell md:hidden">
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.customer}
                            </p>
                            {/*<p className="text-xs text-gray-800 dark:text-white">*/}
                            {/*    {props?.row?.original?.partner}*/}
                            {/*</p>*/}
                            <p className="text-xs text-gray-800 dark:text-white">
                                {props?.row?.original?.server_type}
                            </p>
                        </span>
                        <span className="hidden md:table-cell">
                            <p className="whitespace-nowrap text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
            },
            // {
            //     accessorFn: (row) => row.partner,
            //     accessorKey: "partner",
            //     header: () => <span className="text-gray-400">PARTNER</span>,
            //     footer: (props) => props.column.id,
            //     enableSorting: false,
            //     cell: (props) => (
            //         <div
            //             className="bottom-10 right-10 z-10"
            //             style={{
            //                 textOverflow: "ellipsis",
            //                 overflow: "auto",
            //             }}
            //         >
            //             <span>
            //                 <p className="text-sm text-gray-800 dark:text-white">
            //                     {props.cell.getValue()?.toString()}
            //                 </p>
            //             </span>
            //         </div>
            //     ),
            //     meta: { columnClasses: "hidden md:table-cell" },
            // },
            {
                accessorFn: (row) => row.server_type,
                accessorKey: "server_type",
                header: () => <span className="text-gray-400">TIPOLOGIA</span>,
                footer: (props) => props.column.id,
                enableSorting: false,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <span>
                            <p className="text-sm text-gray-800 dark:text-white">
                                {props.cell.getValue()?.toString()}
                            </p>
                        </span>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
            {
                accessorFn: (row) => row.created_at,
                accessorKey: "created_at",
                header: () => (
                    <>
                        <div className="table-cell text-gray-400 md:hidden">
                            <div>CREATO</div>
                            <div>AGGIORNATO</div>
                        </div>
                        <span className="hidden text-gray-400 md:table-cell">
                            DATA CREAZIONE
                        </span>
                    </>
                ),
                footer: (props) => props.column.id,
                enableSorting: false,
                cell: (props) => {
                    return (
                        <div
                            className="bottom-10 right-10 z-10"
                            style={{
                                textOverflow: "ellipsis",
                                overflow: "auto",
                            }}
                        >
                            <span className="table-cell md:hidden">
                                <p className="text-xs text-gray-800 dark:text-white">
                                    {props?.row?.original?.created_at}
                                </p>
                                <p className="text-xs text-gray-800 dark:text-white">
                                    {props?.row?.original?.updated_at}
                                </p>
                            </span>
                            <span className="hidden md:table-cell">
                                <p className="text-sm text-gray-800 dark:text-white">
                                    {props.cell.getValue()?.toString()}
                                </p>
                            </span>
                        </div>
                    );
                },
            },
            {
                accessorFn: (row) => row.updated_at,
                accessorKey: "updated_at",
                header: () => (
                    <span className="text-gray-400">DATA AGGIORNAMENTO</span>
                ),
                footer: (props) => props.column.id,
                enableSorting: false,
                cell: (props) => (
                    <div
                        className="bottom-10 right-10 z-10"
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "auto",
                        }}
                    >
                        <p className="text-sm text-gray-800 dark:text-white">
                            {props.cell.getValue()}
                        </p>
                    </div>
                ),
                meta: { columnClasses: "hidden md:table-cell" },
            },
        ],
        []
    );

    return (
        <MyCustomTable
            columns={columns}
            endpoint={"/domain/list"}
            title={"Tenant"}
            description={
                <div className="flex flex-col gap-3">
                    <p>Visualizza i dettagli dei tuoi tenants attivi.</p>
                    <p>
                        Qui, sono elencate le informazioni relative a: nome del
                        tenant, cliente finale, tipologia di macchina, data di
                        creazione del tenant e data dell’ultimo aggiornamento.
                    </p>
                </div>
            }
        />
    );
};

export default Domains;
